import React from 'react';
import IconsMapper from 'common/components/IconsMapper/IconsMapper';
import './SimpleCard.css';

const MergeFieldCta = ({
  merchant,
  icon,
  children,
  mergeField,
  color,
  isMail,
  style = {},
  target = '_blank',
}) => {
  const mergeFieldIndex = 'extended_string_data_' + mergeField;
  const url = merchant.extended_data[mergeFieldIndex];

  return (
    <>
      {url && (
        <SimpleCta
          url={url}
          icon={icon}
          color={color}
          isMail={isMail}
          target={target}
          style={style}
        >
          {children}
        </SimpleCta>
      )}
    </>
  );
};

const SimpleCta = ({
  url,
  icon,
  children,
  color,
  isMail,
  style = {},
  target = '_blank',
  itemProp,
  onClick,
}) => {
  const defaultStyle = {
    backgroundColor: 'var(--tertiary-color)',
    border: '1px solid var(--secondary-color)',
    display: 'flex',
    alignItems: 'center',
    color: 'var(--secondary-color)',
    height: '45px',
    padding: '0 var(--gutter-s)',
    minHeight: '45px',
    ...style,
  };

  // Use visible text content for aria-label to match accessible name
  const visibleText = typeof children === 'string' ? children : '';
  const linkAriaLabel =
    visibleText || (isMail ? 'Envoyer un email' : 'Lien externe');

  return (
    <div
      className="simpleCardWrapp"
      style={color ? { ...defaultStyle, backgroundColor: color } : defaultStyle}
      role="link"
    >
      <a
        className="sl-flex sl-ai-center sl-jc-center sl-grow-1"
        href={isMail ? 'mailto:' + url : url}
        target={target}
        rel="nofollow noopener noreferrer"
        aria-label={linkAriaLabel}
        itemProp={itemProp}
        onClick={onClick}
      >
        <span className="sl-flex sl-ai-center sl-jc-center sl-gap">
          {icon && (
            <IconsMapper
              icon={icon}
              style={{ fontSize: 'clamp(16px, 4vw, 30px)' }}
              aria-hidden="true"
            ></IconsMapper>
          )}
          <span className="sl-title text sl-text-center">{children}</span>
        </span>
      </a>
    </div>
  );
};

export { MergeFieldCta, SimpleCta };
